import 'bootstrap';
import 'jquery';
import 'slick-carousel'
import 'mmenu-js';
import browserUpdate from 'browser-update'

jQuery(document).ready(function () {
    jQuery('.news_slider').slick({
        slidesToShow: 3,
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                arrows: false,
                autoplay:true,
                autoplaySpeed: 3500
            }
        }
        ]
    });

    jQuery('.gallery').slick({
        slidesToShow: 1,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: false
            }
        }
        ]
    });

    jQuery('.main-slider').slick({
        slidesToShow: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: false
            }
        }
        ]
    });
});

document.addEventListener('DOMContentLoaded', () => {

    //browser Update

    browserUpdate({
        required: {
            e: 0,
            i: 0,
            c: 0,
            f: 0,
            o: 0,
            o_a: 0,
            s: 0,
            y: 0,
            v: 0,
            uc: 0,
            ios: 0,
            samsung: 0
        },
        insecure: true
    });

    //mMenu.js
    const mMenu = document.getElementById('mobile-menu');
    if (mMenu)
        new Mmenu("#mobile-menu", {
            "extensions": [
                "pagedim-black",
                "theme-dark"
            ],
            "counters": true
        });

    const menu = document.getElementById('menu');
    if (menu) {
        document.addEventListener('scroll', function () {
            if (window.pageYOffset > menu.offsetTop) {
                menu.classList.add('sticky');
            } else {
                menu.classList.remove('sticky');
            }
        });
    }

    //go To top arrow
    $(".goToTop").click(function () {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });

});